'use client'

import { usePathname } from 'next/navigation'

import ContentHtml from '@/components/home/ContentHtml.jsx'
import { GR_ARTICLE_BY_PATH } from '@/data/grArticles.js'

import styles from './GrArticle.module.css'

/*
 * 烘焙的 SEO 文章頁 —— 舊 WP 部落格(百家樂/輪盤/運彩攻略)搬 React,退 WP 前置。
 * 版型 1:1 對齊舊站 WP(hello-elementor):header 下直接 entry-title + 金底線、760 容器、無卡片。
 * 內文是後台原文,走全站唯一的 dangerouslySetInnerHTML 出入口 ContentHtml;
 * 傳 styles.prose 進去做 scoped 覆蓋(不動共用元件,優惠/公告頁不受影響)。
 * 標題列顯示去掉「- 淘金娛樂城」站名尾;<title> metadata 仍保留完整 SEO 標題(見 routes.meta.js)。
 * 哪一篇由網址比對 grArticles.js 的 path(static export 一條路由一頁,build 時就定了)。
 */
const norm = (p) => {
  let s = (p || '/').replace(/\/+$/, '') || '/'
  try {
    s = decodeURIComponent(s)
  } catch {
    // pathname 已是 decoded 形式就維持原樣
  }
  return s.toLowerCase()
}
const heading = (t) => String(t || '').replace(/\s*[-｜|]\s*淘金娛樂城\s*$/, '').trim()

export default function GrArticle() {
  const a = GR_ARTICLE_BY_PATH[norm(usePathname())]
  if (!a) return null

  return (
    <main className={styles.page}>
      <article className={styles.inner}>
        <h1 className={styles.h1}>{heading(a.title)}</h1>
        <ContentHtml html={a.html} className={styles.prose} />
      </article>
    </main>
  )
}
